import { EventEmitter } from 'events';
import each from 'lodash/each';
import isFunction from 'lodash/isFunction';
import { CHANGE } from '../const';

function createStore(spec) {
  const emitter = new EventEmitter();
  emitter.setMaxListeners(1000);

  const store = Object.assign(
    {
      emitChange() {
        emitter.emit(CHANGE);
      },

      emit(eventName, data) {
        emitter.emit(eventName, data);
      },

      addChangeListener(callback) {
        emitter.on(CHANGE, callback);
      },

      removeChangeListener(callback) {
        emitter.removeListener(CHANGE, callback);
      },

      addSingleChangeListener(constant, callback) {
        emitter.on(constant, callback);
      },

      removeSingleChangeListener(constant, callback) {
        emitter.removeListener(constant, callback);
      },
    },
    spec
  );

  // Auto-bind store methods for convenience
  each(store, (val, key) => {
    if (isFunction(val)) {
      store[key] = store[key].bind(store);
    }
  });

  return store;
}

/**
 * This function will add the variants in default key of device_platform_map,
 * which are not linked to any other platforms.
 * @param {Object} map
 * @param {Array} variants
 * @returns
 */
export const updateDevicePlatformMapDefault = (map, variants) => {
  let updatedMap = map || {};
  const existingKeys = Object.keys(updatedMap)
    .map((key) => map[key])
    .flat();

  new Array(variants.length).fill(0).forEach((_, index) => {
    if (!existingKeys.includes(index)) {
      updatedMap = {
        ...updatedMap,
        default: [...(updatedMap.default || []), index],
      };
    }
  });

  return updatedMap;
};

export default createStore;
